import { createTheme } from '@material-ui/core';
import { lime, yellow, indigo, purple, pink, teal, blue, green } from '@material-ui/core/colors';

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    danger: Palette['primary'];
    persimmon: Palette['primary'];
    sunglow: Palette['primary'];
    minsk: Palette['primary'];
    sanMarino: Palette['primary'];
    monaco: Palette['primary'];
    pyrenean: Palette['primary'];
    highlands: Palette['primary'];
    alps: Palette['primary'];
    light: Palette['primary'];
  }

  interface PaletteOptions {
    danger: PaletteOptions['primary'];
    persimmon: PaletteOptions['primary'];
    sunglow: PaletteOptions['primary'];
    minsk: PaletteOptions['primary'];
    sanMarino: PaletteOptions['primary'];
    monaco: PaletteOptions['primary'];
    pyrenean: PaletteOptions['primary'];
    highlands: PaletteOptions['primary'];
    alps: PaletteOptions['primary'];
    light: PaletteOptions['primary'];
  }
}

const theme = createTheme({
  typography: {
    // @ts-ignore
    useNextVariants: true,
  },
  palette: {
    primary: { main: '#7bb5b1', light: '#C1E4E8', contrastText: '#27281A', dark: '#006463' },
    secondary: { main: '#eec729', contrastText: '#ffffff' },
    danger: { main: '#fe7575', contrastText: '#ffffff' },
    grey: {
      100: '#F2F2F2',
      500: '#78787C',
    },
    warning: {
      main: '#FE6F46',
      light: '#FFE1D9',
    },
    light: { main: '#FFFFFF' },
    persimmon: {
      ...lime,
      main: '#FFBBA4',
      dark: '#FE6F46',
      light: '#FFF1ED',
      contrastText: '#ffffff',
    },
    sunglow: {
      ...yellow,
      main: '#FDC635',
      dark: '#F4B100',
      light: '#FFF4C1',
      contrastText: '#ffffff',
    },
    minsk: {
      ...purple,
      main: '#A286C5',
      dark: '#532D83',
      light: '#FBE3FF',
      contrastText: '#ffffff',
    },
    sanMarino: {
      ...indigo,
      main: '#878DC5',
      dark: '#414CB3',
      light: '#EDE5D6',
      contrastText: '#ffffff',
    },
    pyrenean: {
      ...teal,
      main: '#3AB7A5',
      dark: '#2A7E72',
      light: '#A8E6DD',
      contrastText: '#ffffff',
    },
    monaco: {
      ...pink,
      main: '#E68FA3',
      dark: '#B35F73',
      light: '#FAD4DC',
      contrastText: '#ffffff',
    },
    alps: {
      ...blue,
      main: '#4A90E2',
      dark: '#2C5F99',
      light: '#D6E9FA',
      contrastText: '#ffffff',
    },
    highlands: {
      ...green,
      main: '#3B6E47',
      dark: '#24442A',
      light: '#A8D0B0',
      contrastText: '#ffffff',
    },
  },
});

theme.palette.augmentColor(theme.palette.persimmon);
theme.palette.augmentColor(theme.palette.sunglow);
theme.palette.augmentColor(theme.palette.minsk);
theme.palette.augmentColor(theme.palette.sanMarino);
theme.palette.augmentColor(theme.palette.monaco);
theme.palette.augmentColor(theme.palette.pyrenean);
theme.palette.augmentColor(theme.palette.alps);
theme.palette.augmentColor(theme.palette.highlands);

export default theme;
